import { render, staticRenderFns } from "./PublishDate.vue?vue&type=template&id=d599dffc&scoped=true&"
import script from "./PublishDate.vue?vue&type=script&lang=js&"
export * from "./PublishDate.vue?vue&type=script&lang=js&"
import style0 from "./PublishDate.vue?vue&type=style&index=0&id=d599dffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d599dffc",
  null
  
)

export default component.exports